import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';

const routes: Routes = [
  {
    path: '',
    loadChildren: () => import('./pages/search/search.module').then(m => m.SearchModule)
  },
  {
    path: 'notfound',
    loadChildren: () => import('./pages/notfound/notfound.module').then(m => m.NotfoundModule)
  },
  {
    path: 'inappbrowser/:app',
    loadChildren: () => import('./pages/inappbrowser/inappbrowser.module').then(m => m.InappbrowserModule)
  },
  {
    path: ':app',
    loadChildren: () => import('./pages/link/link.module').then(m => m.LinkModule)
  },
  {
    path: ':app/web',
    loadChildren: () => import('./pages/use/use.module').then(m => m.UseModule)
  },
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule { }
